import { IconButton } from "./buttons";

export const TitleDescriptionText = ({ title, description, style, className, editable = false, onClick }) => {



  return (
    <div
      className={`small-standard-padding-bottom standard-padding-top title-description ${className}`}
      style={{ ...style }}
      
    >
      <p
        className="course-title"
      >
        {title}
        {editable && <IconButton onClick={onClick} icon2={"edit"} />}        
      </p>
      <p className="progress-description">{description}</p>
      
    </div>
  );
};
